import {
  MISLABORATORIOS_SUCCESS,
  MISLABORATORIOS_LOADING,
  MISLABORATORIOS_ERROR,
  MISLABORATORIOS_RESET,
  MISLABORATORIOS_ARCHIVOBASE64LABO,
  MISLABORATORIOS_RESET_ARCHIVOBASE64LABO,
  RESET_PORTAL_CONTEXT,
} from "../ActionTypes";
import misLaboratoriosInitialState from "../initialStates/misLaboratoriosInitialState";

const misLaboratorios = (state, { payload, type }) => {
  switch (type) {
    case MISLABORATORIOS_LOADING:
      return {
        ...state,
        misLaboratorios: {
          ...state.misLaboratorios,
          error: false,
          loading: true,
        },
      };
    case MISLABORATORIOS_SUCCESS:
      return {
        ...state,
        misLaboratorios: {
          ...state.misLaboratorios,
          loading: false,
          error: false,
          data: payload,
        },
      };
    case MISLABORATORIOS_ERROR:
      return {
        ...state,
        misLaboratorios: {
          ...state.misLaboratorios,
          error: payload,
          loading: false,
        },
      };
    case MISLABORATORIOS_ARCHIVOBASE64LABO:
      return {
        ...state,
        misLaboratorios: {
          ...state.misLaboratorios,
          loading: false,
          error: false,
          archivobase64labo: payload,
        },
      };
    case MISLABORATORIOS_RESET_ARCHIVOBASE64LABO:
      return {
        ...state,
        misLaboratorios: {
          ...state.misLaboratorios,
          loading: false,
          error: false,
          archivobase64labo: null,
        },
      };
    case MISLABORATORIOS_RESET:
      return misLaboratoriosInitialState;
    case RESET_PORTAL_CONTEXT:
      return misLaboratoriosInitialState;

    default:
      return state;
  }
};

export default misLaboratorios;
